export default new class ContactForm {
    constructor() {
        this.form = 'contact-form';
        this.inValidSelector = '_invalid';
        this.contactFormInputSelector = 'contact-form__input';
        this.preLoaderSelector = 'contact-form__preloader';
        this.successSelector = 'contact-form__success';
        this.handlers();
    }

    handlers() {
        const form = document.querySelector(`.${this.form}`);

        if (!form) { return; }

        form.addEventListener('submit', (e) => {

            e.preventDefault();

            setTimeout(()=> {
                this.contactForm(form);
            });
        });
    }

    contactForm(form) {
        if(form.matches(`.${this.inValidSelector}`)) return;

        const inputs = form.querySelectorAll(`.${this.contactFormInputSelector}`);
        const successSelector = form.querySelector(`.${this.successSelector}`);

        $.request('Feedback::onSend', {
            form: form,
            loading: `.${this.preLoaderSelector}`,
            success: function (){
                successSelector.classList.add('contact-form__success_show');

                setTimeout(() => {
                    for (let input of inputs) {
                        input.value = '';
                        input.dispatchEvent(new Event('change', {
                            bubbles: true,
                        }));
                    }
                    successSelector.classList.remove('contact-form__success_show');
                }, 2000);
            }
        });
    }
}();
